import React from 'react';

import { useTvc } from './useTvc';

import Misson1Component from './mission1';
import Mission2Component from './mission2';

const TvcMobileComponent = () => {
  const { 
    ableMission1, 
    mission1Count,
    ableMission2, 
    updateAbleMisssionState,
    isValidAuth
  } = useTvc();

  return (
    <>
      <Misson1Component 
        ableMission1={ableMission1}
        updateAbleMisssionState={updateAbleMisssionState}
        isValidAuth={isValidAuth}
      />
      
      <Mission2Component 
        mission1Count={mission1Count}
        ableMission2={ableMission2}
        updateAbleMisssionState={updateAbleMisssionState}
        isValidAuth={isValidAuth}
      />
    </>
  );
};

export default TvcMobileComponent;
